import React, { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import WizardForm from '~/components/WizardForm';
import { Stage } from '~/types/Application';
import StepReviewComment from '~/pages/ksa/review/components/StepReviewComment';
import buildNamePath from '~/utils/buildNamePath';
import Section from '~/layouts/Section ';
import ShareTables from './ShareTables';
import ShareholdersProofs from './ShareholdersProofs';
import { useGetPayload } from '~/controllers/wizard';


const ShareholdersMultiple: FC = () => {
  const { t } = useTranslation('ksaReview');
  const [form] = WizardForm.useForm();
  const payload = useGetPayload();

  return (
    <Container className="ShareholdersMultiple">
      <WizardForm
        stage={Stage.ksaReview}
        form={form}
        payloadKey="reviewShareholders"
        handleDraftDataBeforeSave={(v) => v}
      >
        <ShareholdersProofs />
        <Typography.Title level={4}>{t('Review shareholders').toUpperCase()}</Typography.Title>
        <ShareTables />
        <Section formItemLast>
          <StepReviewComment n={buildNamePath('reviewShareholders')} />
        </Section>
      </WizardForm>
    </Container>
  );
};

// const n = (namePath: string | string[]) => [shareholdersKey].concat([namePath].flat());

// const copyMemorandumOrPartnership = 'Upload Copy of Memorandum of Association or Partnership deed';
// const getProofDocumentOptions = () => [
//   {
//     label: i18n.t('Shareholders are listed in company license', { ns: 'fillApplication' }),
//     value: 'Shareholders are listed in company license',
//   },
//   {
//     label: i18n.t(copyMemorandumOrPartnership, { ns: 'fillApplication' }),
//     value: copyMemorandumOrPartnership,
//   },
// ];

const Container = styled.div`
  .ShareholdersMultiple-Collapse {
    margin: -16px;
    margin-bottom: 32px;

    .ant-select-selector {
      max-width: calc(100vw - ${16 * 2 + 8 * 2}px);
    }
  }

  .ShareholdersMultiple-CheckboxItem {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export default ShareholdersMultiple;
